import { useDeleteUnit } from "./api/deleteUnit";
import { Button } from "reactstrap";


const DeleteUnit = ({handleCloseModal, unitId}: DeleteUnitProps)  => {
  
  const deleteUnitMutation = useDeleteUnit({ unitId});
  const handleSubmit = async (): Promise<void> => {
    deleteUnitMutation.mutateAsync({ 
      unitId: unitId
    })

    handleCloseModal();
  }

  return (
    <>
        <label>Είστε σίγουροι οτι θέλετε να διαγράψετε την Μονάδα;</label>
        <div>
          <Button style={{ margin: "10px" }} onClick={handleCloseModal}>Ακύρωση</Button>
          <Button style={{ margin: "10px" }} color='danger' onClick={handleSubmit}>Διαγραφή</Button>
        </div>
    </>
  )
}

interface DeleteUnitProps{
  unitId: number;
  handleCloseModal: () => void;
}

export default DeleteUnit;